import { render, staticRenderFns } from "./McuLoadChart.vue?vue&type=template&id=4b5f59ff&"
import script from "./McuLoadChart.vue?vue&type=script&lang=ts&"
export * from "./McuLoadChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports